import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import ConnectedIncubators from "../pages/ConnectedIncubators";
import NavBar from "../components/NavBar";
import PageContentLoading from "../components/PageContentLoading";
import useMenu from "../utils/Hooks/useMenu";
import useLocale from "../utils/Hooks/useLocale";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.Incubator,
    key: "ConnectedIncubators",
  };
  const screenName = 800
  const locale = useLocale(screenName);

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={{ locale: locale }}>
        <NavBar
          screenName={screenName}
          moduleName={110}
          MenuOptions={menu}
          currentPage={currentPage}
        >
          {locale ? <ConnectedIncubators /> : <PageContentLoading />}
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};

